/*
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2021-09-29 18:06:49
 * @LastEditors: shenlin
 * @LastEditTime: 2021-11-25 10:17:08
 */
const BASE_URL = '/lishui-gov'
const BASE = '/dev-api'
import request from '@/common/api/request'
// 分页列表显示视频    /entLecture/queryEmpowermentForum
export const queryEmpowermentForum = params =>
  request(BASE_URL + '/entLecture/queryEmpowermentForum', { params })
// 新增修改
export const updateOrInsertVideo = data =>
  request.post(BASE_URL + '/govvideoData/updateOrInsertVideo', data)
// 详情
export const getVideoDetailsById = params =>
  request(BASE_URL + '/govvideoData/getVideoDetailsById', { params })
// 上传进度
export const getUploadProcess = params =>
  request(BASE_URL + '/api/file/getUploadProcess', { params })
// 上传视频
export const upload = data =>
  request.post(BASE_URL + '/api/file/uploadVideo', data)

// 文件上传
export const uploadFileUrl =
  process.env.VUE_APP_BASE_API === '/dev-api'
    ? '/dev-api/lishui-gov/api/file/upload'
    : process.env.VUE_APP_BASE_API + '/lishui-gov/api/file/upload'
// export const uploadFileUrl =  request.post(BASE_URL + '/api/file/upload')
// 直播列表
export const listLiveData = params =>
  request(BASE_URL + '/govliveData/listLiveData', { params })
// 直播列表详情
export const liveDataDetail = params =>
  request(BASE_URL + '/govliveData/govliveDataDetail', { params })
// 新增编辑直播
export const insertOrUpdate = params =>
  request.post(BASE_URL + '/govliveData/insertOrUpdate', params)
// 视频列表
export const listVideoData = params =>
  request(BASE_URL + '/govvideoData/listVideoData', { params })
// 视频列表详情
export const VideoDetailsById = params =>
  request(BASE_URL + '/govvideoData/getVideoDetailsById', { params })
// 视频审核记录
export const listVideoExam = params =>
  request(BASE_URL + '/govvideoData/listVideoExam', { params })
// 视频审核记录
export const addVideoDataExam = data =>
  request.post(BASE_URL + '/govvideoData/addVideoDataExam', data)
// 文件上传
export const uploadImg =
  process.env.VUE_APP_BASE_API + BASE_URL + '/api/file/upload'

// 显示丽水市及各个区县数据
export const getArea = params =>
  request(BASE_URL + '/govdictArea/getArea', { params })
// 消息列表
export const listSmsRecord = params =>
  request(BASE_URL + '/smsMessage/listSmsRecord', { params })
// 消息列表-成功 失败
export const querySmsRecord = params =>
  request(BASE_URL + '/smsMessage/querySmsRecord', { params })

// 消息列表-审核状态
export const getMapProcess = params =>
  request(BASE_URL + '/smsMessage/getMapProcess', { params })

// 消息详情
export const getSmsContent = params =>
  request(BASE_URL + '/smsMessage/getSmsContent', { params })

// 消息统计
export const newsStatistics = params =>
  request(BASE_URL + '/smsMessage/statisticsSMS', { params })

// 专员消息推送列表
export const getPushCommissioner = params =>
  request(BASE_URL + '/commerManage/getPushCommissionerByPage', { params })

// 专员消息推送列表
export const addDtalkSMS = params =>
  request.post(BASE_URL + '/smsMessage/addDtalkSMS', params)

// 保存用户消息通知
export const addMovenSMS = params =>
  request.post(BASE_URL + '/smsMessage/addMovenSMS', params)

// 审核列表
export const checkSmsRecordByPage = params =>
  request(BASE_URL + '/smsMessage/checkSmsRecordByPage', { params })

// 通过、驳回
export const checkSendSMS = params =>
  request.post(BASE_URL + '/smsMessage/checkSendSMS', params)
// 删除直播
export const deleteLiveData = params =>
  request(BASE_URL + '/govliveData/deleteLiveData', { params })
// 视频上下架
export const updateVideoStatus = params =>
  request(BASE_URL + '/govvideoData/updateVideoStatus', { params })
// 同步省平台
export const syncLiveData = params => request(BASE_URL + '/govliveData/syncLiveData', { params })
